import { memo } from 'react'
const textColorLevel2 = 'var(--text-color-level2, rgba(26, 26, 26, 0.61))'
const fontSizeSmall = 'var(--fontSizeSmall, 0.75rem)'
import styled from 'astroturf/react'

import { useI18n } from 'locales'
import _Info from "additional_info-Info.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/location/multiple/additional_info.js?styleId=Info";


const Info = /*#__PURE__*/styled('div', null, {
  displayName: "Info",
  styles: _Info
})

const AdditionalInfo = ({ kind, isSelected }) => {
  const { i18n } = useI18n()
  const additionalInfo = {
    inbound_call: i18n.t('booking.location.inbound_call.invitee_instruction'),
    zoom_conference: i18n.t('booking.templates.web_conference_preconfirmation'),
    google_conference: i18n.t('booking.templates.web_conference_preconfirmation'),
    gotomeeting_conference: i18n.t('booking.templates.web_conference_preconfirmation'),
    microsoft_teams_conference: i18n.t('booking.templates.web_conference_preconfirmation'),
    webex_conference: i18n.t('booking.templates.web_conference_preconfirmation')
  }[kind]

  if (!additionalInfo || !isSelected) {
    return null
  }

  return (
    <Info>{additionalInfo}</Info>
  )
}

export default memo(AdditionalInfo)
